import { createRouter, createWebHistory } from 'vue-router';
import { HomeOutlined } from '@ant-design/icons-vue';
import { AUTH_KEYS } from '@/constants';
import Layout from '@/layout/Layout.vue';
import NotFound from '@/views/404.vue';
import Forbidden from '@/views/403.vue';
import Home from '@/views/Home.vue';
import newRequest from './modules/new-request';
import caseManagment from './modules/project-managment';
import notice from './modules/notice';
import achievements from './modules/achievements';
import collectionScheduleManagement from './modules/collection-schedule-management';
import contractManagement from './modules/contract-management';
import invoiceManagement from './modules/invoice-management';
import manifestManagement from './modules/manifest-management';
import licenseManagement from './modules/license-management';
import inquiry from './modules/inquiry';
import account from './modules/account';
import changePassword from './modules/change-password';
import masterAdmin from './modules/master-admin';
import Login from '@/views/Login.vue';
import ResetPass from '@/views/ResetPass.vue';
import accountCreation from '@/views/AccountCreation/Index.vue';
import AccountInfoRegister from '@/views/AccountInfoRegister/Index.vue';
import AccountSelection from '@/views/AccountSelection.vue';
import transAccount from './modules/trans-account';
import inquiryAdmin from './modules/inquiry-admin';
import collectionArea from './modules/collection-area';
import areaPriceSetting from './modules/collection-area';

/**
 * @description 路由配置项 meta 参数
 * @param {Boolean} isHide 是否在左侧菜单栏隐藏
 * @param {String} icon 左侧菜单栏首级图标名称（在 Sider.vue 引入同名组件）
 * @param {String} title 左侧菜单栏和 tabbar 名称
 * @param {Boolean} noTabbar 不添加到 tabbar
 * @param {Boolean} root 是否模块根
 */

declare module 'vue-router' {
  interface RouteMeta {
    isHide?: boolean;
    icon?: any;
    title?: string;
    noTabbar?: boolean;
    root?: boolean;
    auth?: string;
    notClickable?: boolean;
    noBreadcrumb?: boolean;
  }
}

export const selfRouters = [
  newRequest,
  caseManagment,
  contractManagement,
  collectionScheduleManagement,
  achievements,
  manifestManagement,
  invoiceManagement,
  licenseManagement,
  inquiry,
  notice,
  account,
  transAccount,
  changePassword,
  inquiryAdmin,
  masterAdmin,
  collectionArea,
  areaPriceSetting,
];

export const routes = [
  {
    path: '/',
    redirect: '/home',
    component: Layout,
    name: 'Home',
    meta: { title: 'HOME', root: true, noBreadcrumb: true },
    children: [
      {
        name: 'Home',
        path: '/home',
        component: Home,
        meta: { title: 'Home', isHide: true, noBreadcrumb: true }
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { title: 'Login', isHide: true, root: true }
  },
  {
    path: '/account-creation',
    name: 'Account Creation',
    component: accountCreation,
    meta: { isHide: true, root: true, auth: AUTH_KEYS.ACCOUNT_CREATION }
  },
  {
    path: '/reset-pass',
    name: 'ResetPass',
    component: ResetPass,
    meta: { title: 'ResetPass', isHide: true, root: true }
  },
  {
    path: '/user-registration',
    name: 'Register Account Info',
    component: AccountInfoRegister,
    meta: { title: 'ResetPass', isHide: true, root: true }
  },
  {
    path: '/account-selection',
    name: 'Account Selection',
    component: AccountSelection,
    meta: {
      title: 'Account Selection',
      isHide: true,
      root: true,
      auth: AUTH_KEYS.ACCOUNT_SELECTION
    }
  },
  {
    path: '/403',
    name: '403',
    component: Forbidden,
    meta: { isHide: true, root: true }
  },
  {
    path: '/:pathMatch(.*)*',
    name: '404',
    component: NotFound,
    meta: { isHide: true, root: true }
  }
];

export const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_BASE_URL),
  routes: routes
});

export default router;
